import { createContext } from 'react';

const ModalRootContext = createContext({
  onBack: undefined
});
const ModalHeaderContext = createContext({
  variant: undefined
});

export { ModalHeaderContext, ModalRootContext };
